import html2pdf from "html2pdf.js";
import { fmtPLN, pad, round2 } from './helpers';

/**
 * Generate PDF for employee form
 * @param {Object} form - Employee form data
 */
export const generateEmployeeFormPDF = async (form) => {
  // Safe access helper
  const safe = (value, defaultValue = '-') => value || defaultValue;
  
  const htmlContent = `
    <div style="font-family: Arial, sans-serif; padding: 30px; max-width: 800px;">
      <!-- Header -->
      <div style="text-align: center; margin-bottom: 40px; border-bottom: 3px solid #D4AF37; padding-bottom: 20px;">
        <h1 style="margin: 0; color: #333; font-size: 28px;">MR JERRY</h1>
        <h2 style="margin: 10px 0; color: #666; font-size: 20px;">Formularz Pracownika</h2>
        <p style="margin: 5px 0; font-size: 12px; color: #888;">
          Wysłano: ${safe(form.submitted_at ? new Date(form.submitted_at).toLocaleString('pl-PL') : 'Brak daty')}
        </p>
      </div>

      <!-- Personal Data -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          👤 Dane osobowe
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Imię i nazwisko:</strong></td><td style="color: #000;">${safe(form.personal_data?.firstName)} ${safe(form.personal_data?.lastName)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Data urodzenia:</strong></td><td style="color: #000;">${safe(form.personal_data?.birthDate ? new Date(form.personal_data.birthDate).toLocaleDateString('pl-PL') : '-')}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Obywatelstwo:</strong></td><td style="color: #000;">${safe(form.personal_data?.citizenship)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Stanowisko:</strong></td><td style="color: #000;">${safe(form.personal_data?.desiredPosition)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Umowa do:</strong></td><td style="color: #000;">${safe(form.personal_data?.contractUntil ? new Date(form.personal_data.contractUntil).toLocaleDateString('pl-PL') : '-')}</td></tr>
        </table>
      </div>

      <!-- Address -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          🏠 Adres zamieszkania
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Ulica:</strong></td><td style="color: #000;">${safe(form.address?.street)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Kod pocztowy:</strong></td><td style="color: #000;">${safe(form.address?.postalCode)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Miejscowość:</strong></td><td style="color: #000;">${safe(form.address?.city)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Kraj:</strong></td><td style="color: #000;">${safe(form.address?.country)}</td></tr>
        </table>
      </div>

      <!-- Contact -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          📞 Dane kontaktowe
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Telefon:</strong></td><td style="color: #000;">${safe(form.contact?.phone)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Email:</strong></td><td style="color: #000;">${safe(form.contact?.email)}</td></tr>
        </table>
      </div>

      <!-- Payment -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          💰 Dane do wypłaty
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Numer konta:</strong></td><td style="color: #000;">${safe(form.payment?.bankAccount)}</td></tr>
        </table>
      </div>

      <!-- Tax Data -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          🏛️ Dane podatkowe
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Urząd Skarbowy:</strong></td><td style="color: #000;">${safe(form.tax_data?.taxOffice)}</td></tr>
          <tr><td style="padding: 6px 0; color: #666;"><strong>Pierwsza praca:</strong></td><td style="color: #000;">${form.tax_data?.isFirstJob ? '✅ Tak' : '❌ Nie'}</td></tr>
        </table>
      </div>

      <!-- Student Status -->
      <div style="margin-bottom: 30px;">
        <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
          🎓 Status zatrudnienia / nauki
        </h3>
        <table style="width: 100%; font-size: 13px;">
          <tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Uczeń/Student:</strong></td><td style="color: #000;">${form.student_status?.isStudent ? '✅ Tak' : '❌ Nie'}</td></tr>
          ${form.student_status?.isStudent ? `
            <tr><td style="padding: 6px 0; color: #666;"><strong>Szkoła/Uczelnia:</strong></td><td style="color: #000;">${safe(form.student_status.schoolName)}</td></tr>
            <tr><td style="padding: 6px 0; color: #666;"><strong>Kierunek:</strong></td><td style="color: #000;">${safe(form.student_status.fieldOfStudy)}</td></tr>
            <tr><td style="padding: 6px 0; color: #666;"><strong>Ważność legitymacji:</strong></td><td style="color: #000;">${safe(form.student_status.studentIdValidUntil ? new Date(form.student_status.studentIdValidUntil).toLocaleDateString('pl-PL') : '-')}</td></tr>
          ` : ''}
        </table>
      </div>

      <!-- Additional Data -->
      ${form.additional && (form.additional.emergencyContact || form.additional.emergencyPhone) ? `
        <div style="margin-bottom: 30px;">
          <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
            ➕ Dane dodatkowe
          </h3>
          <table style="width: 100%; font-size: 13px;">
            ${form.additional.emergencyContact ? `<tr><td style="padding: 6px 0; width: 40%; color: #666;"><strong>Kontakt awaryjny:</strong></td><td style="color: #000;">${safe(form.additional.emergencyContact)}</td></tr>` : ''}
            ${form.additional.emergencyPhone ? `<tr><td style="padding: 6px 0; color: #666;"><strong>Telefon awaryjny:</strong></td><td style="color: #000;">${safe(form.additional.emergencyPhone)}</td></tr>` : ''}
          </table>
        </div>
      ` : ''}

      <!-- Manager Notes -->
      ${form.manager_data && form.manager_data.notes ? `
        <div style="margin-bottom: 30px;">
          <h3 style="background: #f5f5f5; padding: 10px; margin: 0 0 15px 0; font-size: 16px; border-left: 4px solid #D4AF37;">
            📝 Notatki managera
          </h3>
          <p style="font-size: 13px; line-height: 1.6; white-space: pre-wrap; padding: 10px; background: #fafafa; border-radius: 4px;">
            ${safe(form.manager_data.notes)}
          </p>
        </div>
      ` : ''}

      <!-- Footer -->
      <div style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #ddd; font-size: 11px; color: #999; text-align: center;">
        <p>Wygenerowano: ${new Date().toLocaleString('pl-PL')}</p>
        <p>Status: ${getStatusLabel(form.manager_data?.status)}</p>
      </div>
    </div>
  `;

  const opt = {
    margin: 15,
    filename: `formularz_${safe(form.personal_data?.firstName, 'Pracownik')}_${safe(form.personal_data?.lastName, 'Brak')}_${new Date().toISOString().split('T')[0]}.pdf`,
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  await html2pdf().set(opt).from(htmlContent).save();
};

// Helper function for status labels
function getStatusLabel(status) {
  const labels = {
    do_przejrzenia: 'Do przejrzenia',
    przejrzany: 'Przejrzany',
    zaakceptowany: 'Zaakceptowany',
    odrzucony: 'Odrzucony'
  };
  return labels[status] || 'Nieznany';
}

/**
 * Generate PDF for daily tips report
 * @param {Object} params - Report parameters
 * @param {Array} waiters - List of waiters
 * @param {Array} entries - List of tip entries
 * @param {Object} closedDays - Closed days data
 * @param {string} location - Location name
 * @param {number} waiterShare - Waiter share percentage
 * @param {number} kitchenShare - Kitchen share percentage
 */
export const generateTipsPDF = async (params, waiters, entries, closedDays, location, waiterShare, kitchenShare) => {
  const { fromDate, toDate } = params;
  
  const filtered = entries.filter(e => e.date >= fromDate && e.date <= toDate);
  
  // Group by date
  const byDate = {};
  filtered.forEach(e => {
    if (!byDate[e.date]) byDate[e.date] = [];
    byDate[e.date].push(e);
  });

  const sortedDates = Object.keys(byDate).sort();

  let totalTips = 0;
  let totalDays = 0;
  let totalToWaiters = 0;
  let totalToKitchen = 0;

  const dayRows = sortedDates.map(date => {
    const dayTotal = byDate[date].reduce((sum, e) => sum + e.amount, 0);
    const toWaiters = round2(dayTotal * waiterShare);
    const toKitchen = round2(dayTotal * kitchenShare);
    const dayStatus = closedDays[date] ? "✓ Zamknięty" : "Otwarty";

    totalTips += dayTotal;
    totalToWaiters += toWaiters;
    totalToKitchen += toKitchen;
    totalDays++;

    return `
      <tr>
        <td style="border:1px solid #ccc;padding:8px;">${date}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(dayTotal)}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(toWaiters)}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(toKitchen)}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:center;">${dayStatus}</td>
      </tr>
    `;
  }).join('');

  const htmlContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <div style="text-align: center; margin-bottom: 30px;">
        <h1 style="margin: 0; color: #333;">MR JERRY</h1>
        <h2 style="margin: 10px 0; color: #666;">Raport Napiwków</h2>
        <p style="margin: 5px 0; font-size: 14px; color: #888;">
          ${location} | ${fromDate} - ${toDate}
        </p>
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
        <thead>
          <tr style="background-color: #f0f0f0;">
            <th style="border:1px solid #ccc;padding:8px;text-align:left;">Data</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Suma</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Kelnerzy (${waiterShare * 100}%)</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Kuchnia (${kitchenShare * 100}%)</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:center;">Status</th>
          </tr>
        </thead>
        <tbody>
          ${dayRows}
        </tbody>
        <tfoot>
          <tr style="background-color: #e0e0e0; font-weight: bold;">
            <td style="border:1px solid #ccc;padding:8px;">RAZEM (${totalDays} dni)</td>
            <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(totalTips)}</td>
            <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(totalToWaiters)}</td>
            <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(totalToKitchen)}</td>
            <td style="border:1px solid #ccc;padding:8px;"></td>
          </tr>
        </tfoot>
      </table>

      <div style="margin-top: 30px; font-size: 12px; color: #666;">
        <p>Wygenerowano: ${new Date().toLocaleString('pl-PL')}</p>
      </div>
    </div>
  `;

  const opt = {
    margin: 10,
    filename: `napiwki_${fromDate}_${toDate}.pdf`,
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  return html2pdf().set(opt).from(htmlContent).save();
};

/**
 * Generate PDF for billard report
 * @param {Object} params - Report parameters
 * @param {Array} billardEntries - List of billard entries
 * @param {string} location - Location name
 */
export const generateBillardPDF = async (params, billardEntries, location) => {
  const { fromDate, toDate } = params;
  
  const filtered = billardEntries.filter(e => e.date >= fromDate && e.date <= toDate);
  
  // Group by date
  const byDate = {};
  filtered.forEach(e => {
    if (!byDate[e.date]) byDate[e.date] = [];
    byDate[e.date].push(e);
  });

  const sortedDates = Object.keys(byDate).sort();

  let totalAmount = 0;
  let totalDays = sortedDates.length;

  const dayRows = sortedDates.map(date => {
    const dayTotal = byDate[date].reduce((sum, e) => sum + e.amount, 0);
    totalAmount += dayTotal;

    return `
      <tr>
        <td style="border:1px solid #ccc;padding:8px;">${date}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${byDate[date].length}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(dayTotal)}</td>
      </tr>
    `;
  }).join('');

  const htmlContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <div style="text-align: center; margin-bottom: 30px;">
        <h1 style="margin: 0; color: #333;">MR JERRY</h1>
        <h2 style="margin: 10px 0; color: #666;">Raport Bilard</h2>
        <p style="margin: 5px 0; font-size: 14px; color: #888;">
          ${location} | ${fromDate} - ${toDate}
        </p>
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
        <thead>
          <tr style="background-color: #f0f0f0;">
            <th style="border:1px solid #ccc;padding:8px;text-align:left;">Data</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Liczba gier</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Kwota</th>
          </tr>
        </thead>
        <tbody>
          ${dayRows}
        </tbody>
        <tfoot>
          <tr style="background-color: #e0e0e0; font-weight: bold;">
            <td style="border:1px solid #ccc;padding:8px;">RAZEM (${totalDays} dni)</td>
            <td style="border:1px solid #ccc;padding:8px;text-align:right;">${filtered.length}</td>
            <td style="border:1px solid #ccc;padding:8px;text-align:right;">${fmtPLN(totalAmount)}</td>
          </tr>
        </tfoot>
      </table>

      <div style="margin-top: 30px; font-size: 12px; color: #666;">
        <p>Wygenerowano: ${new Date().toLocaleString('pl-PL')}</p>
      </div>
    </div>
  `;

  const opt = {
    margin: 10,
    filename: `bilard_${fromDate}_${toDate}.pdf`,
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  return html2pdf().set(opt).from(htmlContent).save();
};

/**
 * Generate PDF for kitchen losses report
 * @param {Object} params - Report parameters
 * @param {Array} kitchenLosses - List of kitchen loss entries
 * @param {string} location - Location name
 */
export const generateKitchenLossesPDF = async (params, kitchenLosses, location) => {
  const { fromDate, toDate, category } = params;
  
  let filtered = kitchenLosses.filter(e => e.date >= fromDate && e.date <= toDate);
  
  if (category && category !== 'all') {
    filtered = filtered.filter(e => e.category === category);
  }

  // Group by product
  const byProduct = {};
  filtered.forEach(loss => {
    loss.items.forEach(item => {
      const key = item.product_name || item.product_id;
      if (!byProduct[key]) {
        byProduct[key] = { kg: 0, g: 0 };
      }
      if (item.unit === 'kg') {
        byProduct[key].kg += item.quantity;
      } else {
        byProduct[key].g += item.quantity;
      }
    });
  });

  const productRows = Object.keys(byProduct).sort().map(productName => {
    const { kg, g } = byProduct[productName];
    const totalKg = kg + (g / 1000);
    return `
      <tr>
        <td style="border:1px solid #ccc;padding:8px;">${productName}</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${kg.toFixed(2)} kg</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${g} g</td>
        <td style="border:1px solid #ccc;padding:8px;text-align:right;">${totalKg.toFixed(2)} kg</td>
      </tr>
    `;
  }).join('');

  const htmlContent = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <div style="text-align: center; margin-bottom: 30px;">
        <h1 style="margin: 0; color: #333;">MR JERRY</h1>
        <h2 style="margin: 10px 0; color: #666;">Raport Strat Kuchennych</h2>
        <p style="margin: 5px 0; font-size: 14px; color: #888;">
          ${location} | ${fromDate} - ${toDate}
        </p>
        ${category && category !== 'all' ? `<p style="margin: 5px 0; font-size: 14px; color: #888;">Kategoria: ${category}</p>` : ''}
      </div>

      <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
        <thead>
          <tr style="background-color: #f0f0f0;">
            <th style="border:1px solid #ccc;padding:8px;text-align:left;">Produkt</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Kilogramy</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Gramy</th>
            <th style="border:1px solid #ccc;padding:8px;text-align:right;">Suma (kg)</th>
          </tr>
        </thead>
        <tbody>
          ${productRows}
        </tbody>
      </table>

      <div style="margin-top: 20px;">
        <p><strong>Liczba wpisów:</strong> ${filtered.length}</p>
      </div>

      <div style="margin-top: 30px; font-size: 12px; color: #666;">
        <p>Wygenerowano: ${new Date().toLocaleString('pl-PL')}</p>
      </div>
    </div>
  `;

  const opt = {
    margin: 10,
    filename: `straty_kuchenne_${fromDate}_${toDate}.pdf`,
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  return html2pdf().set(opt).from(htmlContent).save();
};
